import React, { createContext, useContext, useEffect, useState } from 'react';

// Crear el contexto
const TimeContext = createContext();

// Crear un proveedor del contexto
export function TimeProvider({ children }) {

  const [timer, setTimer] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((timer) => timer + 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  };

  return (
    <TimeContext.Provider value={formatTime(timer)}>
      {children}
    </TimeContext.Provider>
  );
}

// Función personalizada para usar el contexto
export function useTime() {
  return useContext(TimeContext);
}
